/** Surfaces and the monospace font. */

export const surface = {
  white: '#fff',
} as const

export const monoFontFamily = '"SF Mono", "Fira Code", monospace'
